<template>
  <div class="basic-info">
    <div v-for="basic in ringData" :key="basic.name" class="basic-info-item" :style="{width: basic.width}">
      <img src="../../../assets/basic/basic_area.png" v-if="basic.name === '用地面积'" alt="" class="basic-info-img">
      <img src="../../../assets/basic/basic_investment.png" v-if="basic.name === '楼栋数量'" alt="" class="basic-info-img">
      <img src="../../../assets/basic/basic_person.png" v-if="basic.name === '从业人数'" alt="" class="basic-info-img">
      <img src="../../../assets/basic/basic_housing.png" v-if="basic.name === '建筑面积'" alt="" class="basic-info-img">
      <img src="../../../assets/basic/basic_chuzu.png" v-if="basic.name === '已出租面积'" alt="" class="basic-info-img">
      <img src="../../../assets/basic/basic_chushou.png" v-if="basic.name === '已出售面积'" alt="" class="basic-info-img">
      <!--<img src="../../../assets/basic_person.png" v-else alt="" class="basic-info-img">-->
      <div>
        <div class="basic-info-value">{{basic.amount}} <span class="basic-info-unit">{{basic.unit}}</span></div>
        <div class="basic-info-name">{{basic.name}}</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'basic-info',
    props: {
      ringData: {
        type: Array,
        default () {
          return []
        }
      }
    }
  }
</script>

<style lang="less">
  .basic-info {
    width: 100%;
    height: 100%;
    padding: 0.1rem 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .basic-info-item {
      width: 33%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      text-align: left;
      .basic-info-img {
        width: 0.8rem;
        height: 0.8rem;
        -webkit-transition: all 0.5s;
        -moz-transition: all 0.5s;
        transition: all 0.5s;

        -webkit-animation: opacityAnimation 1.5s ease-in-out infinite alternate;
        -moz-animation: opacityAnimation 1.5s ease-in-out infinite alternate;
        animation: opacityAnimation 1.5s ease-in-out infinite alternate;
      }
      .basic-info-value {
        font-size: 0.3rem;
        .basic-info-unit {
          font-size: 0.2rem;
          opacity: 0.6;
        }
      }
      .basic-info-name {
        width: 1.2rem;
        font-size: 0.2rem;
        opacity: 0.6;
      }
    }
  }
  @keyframes opacityAnimation  {
    0%{
      opacity: 0.8;
    }
    100%{
      opacity: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Basic/BasicInfo/basicInfo.vue